import { supabase } from '../supabaseClient';

function checkError(error) {
  if (!error) return;
  if (['42P01', 'PGRST205', 'PGRST202'].includes(error.code)) {
    throw new Error('A integração INMET ainda não foi publicada no banco. Contate o administrador.');
  }
  throw new Error(error.message || 'Não foi possível consultar o cache INMET.');
}

function validateCode(code) {
  if (typeof code !== 'string' || !/^[A-Z]\d{3}$/.test(code)) {
    throw new Error('Código de estação INMET inválido.');
  }
}

export async function listInmetStations() {
  const stations = [];
  for (let offset = 0; ; offset += 500) {
    const { data, error } = await supabase.from('inmet_estacoes')
      .select('codigo,nome,uf,latitude,longitude,altitude,situacao,catalogo_em')
      .order('codigo').range(offset, offset + 499);
    checkError(error);
    stations.push(...data);
    if (data.length < 500) return stations;
  }
}

export async function getInmetObservations(code) {
  validateCode(code);
  const { data, error } = await supabase.from('inmet_observacoes')
    .select('codigo,leituras,coletado_em,tentativa_em,erro').eq('codigo', code).maybeSingle();
  checkError(error);
  return data;
}
